function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useCallback, forwardRef, useImperativeHandle, useState } from 'react';
import { Pressable, StyleSheet } from 'react-native';
import Animated, { useSharedValue, withSpring, useAnimatedStyle, Extrapolation, interpolate } from 'react-native-reanimated';

const toggleAccessibilityState = pressed => {
  const accessbilityState = {
    accessibilityState: {
      checked: pressed
    }
  };
  return accessbilityState;
};

const ToggleIcon = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    initIsSelected = true,
    First,
    Second,
    onPress,
    accessibility
  } = _ref;
  const [isPressed, setIsPressed] = useState(initIsSelected);
  const pressed = useSharedValue(initIsSelected ? 1 : 0);
  const secondStyle = useAnimatedStyle(() => {
    return {
      transform: [{
        scale: interpolate(pressed.value, [0, 1], [1, 0], Extrapolation.CLAMP)
      }]
    };
  });
  const firstStyle = useAnimatedStyle(() => {
    return {
      transform: [{
        scale: pressed.value
      }],
      opacity: pressed.value
    };
  });
  useImperativeHandle(ref, () => ({
    updateIcon: isSelected => {
      pressed.value = withSpring(isSelected ? 1 : 0);
      setIsPressed(isSelected);
    }
  }));
  const onIconPress = useCallback(() => {
    if (pressed.value === 0 || pressed.value === 1) {
      const newValue = pressed.value ? 0 : 1;
      setIsPressed(newValue === 1);
      pressed.value = withSpring(newValue);
      onPress && onPress();
    }
  }, [onPress, pressed]);
  return /*#__PURE__*/React.createElement(Pressable, _extends({}, accessibility, {
    accessibilityRole: "button"
  }, toggleAccessibilityState(isPressed), {
    onPress: onIconPress,
    style: styles.container
  }), /*#__PURE__*/React.createElement(Animated.View, {
    style: [StyleSheet.absoluteFillObject, secondStyle]
  }, /*#__PURE__*/React.createElement(Second, null)), /*#__PURE__*/React.createElement(Animated.View, {
    style: firstStyle
  }, /*#__PURE__*/React.createElement(First, null)));
});
const styles = StyleSheet.create({
  container: {
    alignSelf: 'flex-start'
  }
});
export default ToggleIcon;
//# sourceMappingURL=ToggleIcon.js.map